export default (props) => (
  /**
   * Ícone balão de diálogo com cor parametrizada
   * Descreve os outros dois modulos disponiveis, encontrado
   * em um icone ao lado de 'Contato'.
   */
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.69476 7.51608V8.0058V8.49552H3.67268V8.0058V7.51608H7.69476ZM3.67268 5.24409H11.5995V6.22353H3.67268V5.73381V5.24409ZM3.67268 2.9721H11.5995V3.95154H3.67268V3.46182V2.9721ZM13.7908 9.30057C13.7908 9.6346 13.5189 9.90649 13.1849 9.90649H10.4468L7.6361 12.2955L4.8254 9.90649H2.08732C1.75312 9.90649 1.48139 9.6346 1.48139 9.30057V2.16642C1.48139 1.83223 1.75312 1.56049 2.08732 1.56049H13.1849C13.5189 1.56049 13.7908 1.83223 13.7908 2.16642V9.30057ZM13.1849 0.581055H2.08732C1.21172 0.581055 0.501953 1.29082 0.501953 2.16642V9.30057C0.501953 10.1762 1.21172 10.8859 2.08732 10.8859H4.46537L7.6361 13.5811L10.8068 10.8859H13.1849C14.0605 10.8859 14.7702 10.1762 14.7702 9.30057V2.16642C14.7702 1.29082 14.0605 0.581055 13.1849 0.581055Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
